'use strict';

/**
 * @classname GA4BeginCheckout
 * @classdesc GA4 購入手続き開始
 */
export default class GA4BeginCheckout {
	/**
	 * @constructor
	 * @param {jQuery} $e - .btn--checkout
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`);
		this._$e = $e;
		this._href = $e.attr('href');
		this._$anchorCartDelete = $e.closest('.area--cart').find('.list--cart-item .anchor--cart-delete');
		$e.on('click', (e) => this.onClick(e));
	};


	/**
	 * clickのコールバック
	 *
	 * @memberof GA4BeginCheckout
	 * @return undefined
	 */
	onClick(e) {
		console.log(`${this.constructor.name}.onClick`);
		if(window.dataLayer) {
			// dataLayerがある場合
			e.preventDefault();
			e.stopPropagation();
			let items = [];
			this._$anchorCartDelete.each((idx, e) => {
				const $e = $(e);
				const tmp = {
					item_name: $e.attr('data-item-name'),
					item_id: $e.attr('data-item-id'),
					price: parseInt($e.attr('data-price')),
					item_category: $e.attr('data-category'),
					item_category2: $e.attr('data-category2'),
					item_category3: $e.attr('data-category3'),
					item_variant: $e.attr('data-item-variant'),
					currency: $e.attr('data-currency'),
					discount: parseInt($e.attr('data-discount')),
					quantity: parseInt($e.closest('.block__item--cart-quantity').find('.quantity').val())
				};
				items.push(tmp);
			})
			console.log(items);
			window.dataLayer.push({
				event: 'begin_checkout',
				ecommerce: {
					items: items
				},
				'eventCallback': () => {
					// DataLayerにデータを送信後に通常処理へ
					location.href = this._href;
				},
				'eventTimeout' : 2000
			});
			// timeoutしたらそのまま遷移
			setTimeout(() => {
				location.href = this._href;
			}, 2500);
		}
		// dataLayerがない場合はそのまま遷移
	};
};
